import { ServiceMaker, methods, services } from "@/services";

export const getReconciliationDashboard = () =>
  ServiceMaker(`/finance/reconciliation/dashboard`, methods.GET, services.order);

export const getReconciliationSummary = (fromDate, toDate) =>
  ServiceMaker(`/finance/reconciliation/summary?fromDate=${fromDate}&toDate=${toDate}`, methods.GET, services.order);

export const getReconciliationRecords = () =>
  ServiceMaker(`/finance/reconciliation/records`, methods.GET, services.order);

export const getFraudAlertList = (payload) =>
  ServiceMaker(`dashboard/report-list/table`, methods.POST, services.master, payload);

export const getAbuseReport = (payload) =>
  ServiceMaker(`dashboard/report-list/table`, methods.POST, services.master, payload);

export const blockUser = () =>
  ServiceMaker(`/cap/users/partner/block-users`, methods.GET, services.master);

export const suspiciousReport = (payload) =>
  ServiceMaker(`dashboard/report-list/table`, methods.POST, services.master, payload);

export const fetchDashboardStats = () =>
  ServiceMaker(`/cap/users/partner/block-users-summary?status=INACTIVE`, methods.GET, services.master);